import NumberFormat from 'react-number-format'

function numberToDisplay(number: number) {
    return number.toFixed(2)
}

export function LoanQualification({
    review = false,
    value = '',
    debtToIncomeRatio = 0,
    freeCashFlow = 0,
    monthlyIncome = 0,
    totalCryptoWorth = 0,
    totalDebt = 0,
    totalAssets = 0,
    totalNetWorth = 0,
}: {
    review?: boolean
    value?: string
    debtToIncomeRatio?: number
    freeCashFlow?: number
    monthlyIncome?: number
    totalCryptoWorth?: number
    totalDebt?: number
    totalAssets?: number
    totalNetWorth?: number
}) {
    return (
        <div>
            {review ? (
                <>
                    <div>
                        <h3>Applicant details</h3>

                        <p className='my-6 text-lg'>
                            Loan amount requested:{' '}
                            <span className='text-black'>
                                {value ? (
                                    <>
                                        $
                                        <NumberFormat
                                            value={value}
                                            type='text'
                                            thousandSeparator={true}
                                            fixedDecimalScale={true}
                                            decimalScale={2}
                                            displayType={'text'}
                                            className='inline'
                                        />
                                    </>
                                ) : (
                                    '$2,500.00'
                                )}
                            </span>
                        </p>
                        <p className='text-md'>
                            Location:{' '}
                            <span className='text-black'>
                                United States of America
                            </span>
                        </p>
                        <p className='text-md'>
                            Loan term:{' '}
                            <span className='text-black'>6 months</span>
                        </p>
                        <p className='text-md'>
                            Interest rate:{' '}
                            <span className='text-black'>15% APY</span>
                        </p>
                        <p className='text-md'>
                            Collateral:{' '}
                            <span className='text-black'>None required</span>
                        </p>
                    </div>
                    <div className='mt-8'>
                        <h3 className='mb-8'>Pre-qualification information</h3>
                        <p className='text-md'>
                            Total net worth:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalNetWorth)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total cryptocurrency assets:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalCryptoWorth)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total assets:{' '}
                            <span className='text-black'>
                                ${numberToDisplay(totalAssets)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total debt:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalDebt)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Monthly income:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(monthlyIncome)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Free cashflow:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(freeCashFlow)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Debt-to-income ratio:{' '}
                            <span className='text-black'>
                                {' '}
                                {numberToDisplay(debtToIncomeRatio)}%
                            </span>
                        </p>
                        <p className='text-md'>
                            Masa DeFi credit score:{' '}
                            <span className='text-black'>Coming soon</span>
                        </p>

                        <p className='flex flex-row items-center mt-8 text-xl'>
                            Recomendation:{' '}
                            <h2 className='m-0 ml-4 text-success'>Approve</h2>
                        </p>
                    </div>
                </>
            ) : (
                <>
                    {' '}
                    <div>
                        <h3>You are pre-qualified for a loan</h3>

                        <p className='my-6 text-lg'>
                            Maximum loan amount:{' '}
                            <span className='text-black'>$2,500.00</span>
                        </p>
                        <p className='text-md'>
                            Loan term:{' '}
                            <span className='text-black'>6 months</span>
                        </p>
                        <p className='text-md'>
                            Interest rate:{' '}
                            <span className='text-black'>15% APY</span>
                        </p>
                        <p className='text-md'>
                            Collateral:{' '}
                            <span className='text-black'>None required</span>
                        </p>
                        <p className='text-sm italic'>
                            Terms will be confirmed when you have selected the
                            loan amount
                        </p>
                    </div>
                    <div className='mt-8'>
                        <h3 className='mb-8'>
                            We used the following information to pre-qualify you
                        </h3>
                        <p className='text-md'>
                            Total net worth:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalNetWorth)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total cryptocurrency assets:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalCryptoWorth)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total assets:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalAssets)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Total debt:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(totalDebt)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Monthly income:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(monthlyIncome)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Free cashflow:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(freeCashFlow)}{' '}
                            </span>
                        </p>
                        <p className='text-md'>
                            Debt-to-income ratio:{' '}
                            <span className='text-black'>
                                {' '}
                                ${numberToDisplay(debtToIncomeRatio)} %
                            </span>
                        </p>
                        <p className='text-md'>
                            Masa DeFi credit score:{' '}
                            <span className='text-black'>Coming soon</span>
                        </p>
                    </div>
                </>
            )}
        </div>
    )
}
